import { faSpinner, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Dialog from "@radix-ui/react-dialog";
import { useQuery } from "@tanstack/react-query";
import { Editor } from "@tiptap/core";
import { EditorContent, useEditor } from "@tiptap/react";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { format } from "timeago.js";
import useLocalStorageState from "use-local-storage-state";

import { loadExtensions } from "@/extensions";
import { useQueries } from "@/hooks";
import { getPromptHistory } from "@/hooks/useQueries/promptHistory";
import { Page, PromptHistory as PromptHistoryType } from "@/types";

import styles from "./PromptHistory.module.scss";

export const PromptHistory = ({}: {}) => {
  const { currentProject } = useQueries();

  const { data, isFetching } = useQuery({
    queryKey: ["prompt-history", currentProject?.slug],
    initialData: [],
    queryFn: ({ signal }) => getPromptHistory(signal, currentProject?.slug),
    enabled: Boolean(currentProject?.id),
  });
  const uniqueHumanPrompts = Array.from(
    data.reduce((map, item) => map.set(item.human, item), new Map()).values()
  );

  if (!currentProject) return <></>;

  const [currentPrompt, setCurrentPrompt] = useState<PromptHistoryType>();

  const [input, setInput] = useLocalStorageState<string>(`ldgV2Input-${currentProject?.slug}`);

  useEffect(() => {
    if (data.length) setCurrentPrompt(data[0]);
  }, [data]);

  return (
    <>
      <Dialog.Close asChild>
        <button className={styles.iconButton} aria-label="Close">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Dialog.Close>
      <div className={styles.wrapper}>
        {isFetching && (
          <div className={styles.loading}>
            Loading...
            <FontAwesomeIcon icon={faSpinner} spin />
          </div>
        )}
        <div className={styles.promptPreview}>
          <div className={styles.promptButtons}>
            <button
              onClick={() => {
                setInput(currentPrompt?.human);
                // setPrompt(currentPrompt?.system);
              }}
            >
              Set as prompt
            </button>
          </div>
          <div className={styles.scroller}>
            <h1>User</h1>
            <div className={styles.human}>{currentPrompt?.human}</div>
            <h1>System</h1>
            <div className={styles.system}>{currentPrompt?.system}</div>
          </div>
        </div>
        <div className={styles.prompts}>
          {uniqueHumanPrompts.map((prompt, i) => (
            <div
              className={classNames(styles.prompt, {
                [styles.active]: prompt == currentPrompt,
              })}
              key={`${prompt}-prompt-${i}`}
              onClick={() => setCurrentPrompt(prompt)}
            >
              <div className={styles.title}>{prompt.human}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
